import { create } from 'zustand'
import { toast } from 'react-toastify'
import type { TurmaListItem } from '@/types'
import * as turmasApi from '@/api/turmas'

interface TurmasState {
  data: TurmaListItem[]
  totalRecords: number
  solicitacoesPendentes: number
  loading: boolean
  error: string | null
  modalAberto: boolean
  filters: turmasApi.FiltrosDeTurmas
  setPage: (page: number, limit: number) => void
  fetchTurmas: () => Promise<void>
  solicitar: (valores: turmasApi.ValoresDaSolicitacao, arquivo: File | null) => Promise<void>
  setModalAberto: (aberto: boolean) => void
}

export const useTurmasStore = create<TurmasState>((set, get) => ({
  data: [],
  totalRecords: 0,
  solicitacoesPendentes: 0,
  loading: false,
  error: null,
  modalAberto: false,
  filters: { page: 1, limit: 15 },
  setPage: (page, limit) => set({ filters: { page, limit } }),
  setModalAberto: (modalAberto) => set({ modalAberto }),
  fetchTurmas: async () => {
    set({ loading: true, error: null })
    try {
      const resposta = await turmasApi.listarTurmas(get().filters)
      set({
        data: resposta.rows,
        totalRecords: resposta.count,
        solicitacoesPendentes: resposta.solicitacoesPendentes,
      })
    } catch {
      set({ error: 'Não foi possível carregar as turmas.' })
    } finally {
      set({ loading: false })
    }
  },
  solicitar: async (valores, arquivo) => {
    const turma = await turmasApi.solicitarTurma(valores, arquivo)
    set((state) => ({
      data: [turma, ...state.data],
      totalRecords: state.totalRecords + 1,
      solicitacoesPendentes: state.solicitacoesPendentes + 1,
    }))
    toast.success('Solicitação enviada. Nosso suporte entrará em contato.')
  },
}))
